export const cleanPhoneNumber = (phoneNumber) => {
    let newNumber = phoneNumber.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "").trim()
    if (!newNumber.startsWith("+1")) {
        if (!newNumber.startsWith("1")) {
            newNumber = "+1" + newNumber
        } else {
            newNumber = "+" + newNumber
        }
    }

    return newNumber
}

export const cleanPhoneNumberWithoutCountryCode = (phoneNumber) => {
    if (!phoneNumber) return '';
    let newNumber = phoneNumber.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "").trim();
    if (newNumber.startsWith("+1")) {
        newNumber = newNumber.substring(2);
    } else if (newNumber.startsWith("1") && newNumber.length === 11) {
        newNumber = newNumber.substring(1);
    }
    return newNumber;
}



